import React from 'react';
import classNames from 'classnames';

// This component should act as a base for every CMS rich text.
// The styles applied are taken from the hero WO intro,
// and can be overridden via the [stylesOverride] prop.
// This component is also useful because we have all the needed
// styles classes for every HTML tag in one place, so we know what
// to expect from CMS.
const CmsStyledContent = ({
  text,
  stylesOverride,
}: {
  text: string | JSX.Element | JSX.Element[];
  stylesOverride?: string;
}) => {
  return (
    <div
      className={classNames(
        '[&_h1]:text-white [&_h1]:text-center [&_h1]:m-0',
        '[&_h2]:text-white [&_h2]:m-0 [&_h2]:text-center',
        '[&_h3]:text-white [&_h3]:m-0 [&_h3]:text-center',
        '[&_p]:text-white [&_p]:m-0',
        '[&_strong]:text-blue-light',
        stylesOverride,
      )}
    >
      {text}
    </div>
  );
};

export default CmsStyledContent;
